<template>
  <div id="f-sfs">
    <section id="support">
      <div class="container pb-5 px-md-0">
        <SFSForm
          :offpay="offpay"
          :oto="oto"
          @goToActions="actions = true; goTo('actions')"
          @goToLastyear="lastyear = true; goTo('lastyear')"
        />
      </div>
    </section>

    <section
      v-show="actions"
      id="actions"
      ref="actions"
      class="fb-g6 py-5"
    >
      <b-container>
        <h1
          class="text-center mt-4 mb-5 fc-light"
          v-html="$t('sfs.why.maintitle')"
        ></h1>

        <h2
          class="fc-light mb-4"
          v-html="$t('sfs.why.actions.title')"
        ></h2>
        <b-row>
          <b-col
            v-for="index in Object.keys($t('sfs.why.actions.list'))"
            :key="index"
            lg="6"
            class="fc-light d-flex py-2"
          >
            <b-col
              cols="3"
              sm="2"
            >
              <i
                :class="`fas fa-${
                  ['hiking fa-person-hiking','lightbulb','shapes',
                   'people-carry fa-people-carry-box','cogs fa-gears','moon'][index]
                } fa-shape-circle fa-border fa-lg`"
              ></i>
            </b-col>
            <b-col
              cols="9"
              sm="10"
            >
              <p v-html="$t(`sfs.why.actions.list[${index}]`)"></p>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section
      v-show="lastyear"
      id="lastyear"
      ref="lastyear"
      class="fb-g2 py-5"
    >
      <b-container>
        <h2
          class="blocLarge"
          v-html="$t('sfs.why.numbers.title', {
            year: $t('metrics.edit').split('/')[0] - 1,
          })"
        ></h2>

        <h3
          v-html="$t('sfs.why.numbers.subtitle')"
        ></h3>
        <b-row>
          <b-col
            v-for="n in 3"
            :key="n"
            md="4"
            class="py-4 d-flex flex-column"
          >
            <div
              aria-hidden="true"
              class="text-center"
            >
              <i
                :class="`${
                  ['fas fa-home fa-house','fas fa-users','far fa-file-alt fa-file-lines'][n - 1]
                } fa-shape-circle fa-border fa-lg mb-2`"
              ></i>
            </div>
            <div
              class="h-100"
              v-html="$t(`sfs.why.numbers.list${n}`, numbers)"
            ></div>
          </b-col>
        </b-row>
        <p
          class="text-right"
          v-html="$t('sfs.why.numbers.more')"
        ></p>

        <h3
          class="mt-4 mb-2"
          v-html="$t('sfs.why.money.title')"
        ></h3>
        <b-row class="pt-4">
          <b-col lg="4">
            <div
              v-html="$t('sfs.why.money.intro', {
                percent: $t('metrics.ig-pdonation'),
                year: $t('metrics.edit').split('/')[0] - 1,
              })"
            ></div>
          </b-col>
          <b-col lg="8">
            <Pie />

            <p
              class="mt-2 text-right small"
              v-html="$t('sfs.why.money.outro', {
                date: $d(new Date($t('metrics.edit'))),
              })"
            ></p>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import SFSForm from './Form.vue';
import Pie from './Pie.vue';

export default {
  components: {
    SFSForm,
    Pie,
  },

  props: {
    collapsed: { /* why & lastyear sections hidden */
      type: Boolean,
      default: true,
    },

    offpay: { /* vir & chq */
      type: Boolean,
      default: true,
    },

    oto: { /* one time only */
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      numbers: {
        years: `<b>${this.$t('year.current') - 2001}</b>`,
        members: `<b>${this.$t('metrics.members')}</b>`,
        employees: `<b>${this.$t('metrics.employees')}</b>`,
        projects: `<b>${this.$t('metrics.projects')}</b>`,
        services: `<b>${this.$t('metrics.services')}</b>`,
        ucontrib: `<b>${this.$t('metrics.ucontrib')}</b>`,
        usupport: `<b>${this.$n(+this.$t('metrics.usupport'))}</b>`,
        uvisits: `<b>${this.$n(+this.$t('metrics.uvisits'))}</b>`,
        dlibre: `<b>${this.$n(+this.$t('metrics.dlibre'))}</b>`,
        dblog: `<b>${this.$n(+this.$t('metrics.dblog'))}</b>`,
        events: `<b>${this.$t('metrics.events')}</b>`,
      },
      actions: !this.collapsed,
      lastyear: !this.collapsed,
    };
  },

  methods: {
    goTo(target) {
      setTimeout(() => { this.$refs[target].scrollIntoView({ behavior: 'smooth' }); }, 400);
    },
  },
};
</script>

<style lang="scss">
@import '~vue-fs-commons/src/scss/frama/colors';

#f-sfs {
  --f-i9: #0b1c54;
  .monthly {
    --contextual1: var(--f-o5);
    --contextual2: var(--f-o6);
  }
  .onetime {
    --contextual1: var(--f-f6);
    --contextual2: var(--f-f7);
  }

  .container {
    background-color: transparent !important;
  }

  .ombre {
    background: #fff;
    box-shadow: 0 -1px 1px var(--contextual1);
    border-radius: .5rem;
    border-top: 8px solid var(--contextual1);
    padding: 1em 2em 0;
    .btn-link {
      background: none;
    }
  }

  #form_don + div {
    border-radius: 0 0 .5rem .5rem;
  }

  ul.list-unstyled {
    list-style: none !important;
  }

  .btn-link {
    background: transparent;
  }

  label {
    margin: 0;
  }

  #why, #timeline, #money { /* = scroll to #f-sfs */
    position: absolute;
  }

  #why ~ .container .why,
  #timeline ~ .container .timeline,
  #money ~ .container .money {
    display: none;
  }

  #why:target ~ .container .why,
  #timeline:target ~ .container .timeline,
  #money:target ~ .container .money {
    display: block;
  }

  #support {
    h2 {
      background: var(--f-o6);
      border-radius: .5rem;
      color: #fff;
      font-family: 'Tovari Sans', sans-serif;
      font-size: 2.4rem;
      @media (min-width: 576px) {
        font-size: 3rem;
      }
      font-style: normal;
      line-height: 2.5rem;
      padding: 1.25rem 1.75rem .5rem;
      text-align: center;
      text-transform: uppercase;
      transform: rotate(-2deg);
      width: fit-content;
    }

    h3 {
      color: var(--f-i9);
    }

    .btn-square {
      border-bottom: 1px dashed var(--contextual1);
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0;
      padding: .5rem 0;
      width: 100%;

      label {
        background: none;
        border: none;
        display: flex;
        margin: 0 0 .5rem;
        padding: 0;
        width: 100%;
        @media (min-width: 576px) {
          max-width: calc(50% - 1rem);
        }

        i {
          color: var(--f-d6) !important;
        }

        > span {
          border: 1px solid var(--f-g2);
          border-bottom-width: 3px;
          padding: .5rem;
          height: 100%;
          width: 100%;
        }

        &:hover, &:focus {
          > span {
            border-color: var(--f-g4)
          }
        }
      }

      .active {
        position: relative;

        i { color: var(--contextual2) !important; }

        > span {
          background: linear-gradient(
            45deg,
            #fff calc(100% - 1.25rem),
            var(--contextual2) 1.25rem);
          border-color: var(--contextual2);
        }

        &:hover, &:focus {
          > span {
            border-color: var(--contextual2);
          }
        }

        &::before {
          background-image:
            url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23ffffff' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: top .15rem right .15rem;
          background-size: .75rem .75rem;
          content: '';
          height: 100%;
          position: absolute;
          width: 100%;
        }
      }
    }
  }

  #howmuch {
    .active, :active {
      box-shadow: none;
    }

    .amount {
      line-height: 2em;
      padding: 1em 0;
    }
  }

  .amount {
    .btn {
      display: inline-block;
      font-size: 1.5rem;
      line-height: 20px;
      margin-bottom: 10px;
      padding: 0.67rem 0;
      text-align: center;
      background-color: #fff;
      color: var(--f-g8);
      border: 1px solid #ccc;
      border-radius: 0;
      width: 100%;
      height: 52.8px;
      font-weight: 300;

      &.selected {
        color: #fff;
        background-color: var(--contextual2);
        border-color: var(--contextual2);

        &:hover, &:focus {
          border-color: var(--contextual2);
          opacity: 0.9;
        }
      }

      small {
        display: block;
        font-size: 50%;
        line-height: 15px;
      }
    }

    .input-group {
      height: 52.8px;
      input {
        margin-left: -1px;
      }

      div,
      input {
        font-size: 1.2rem;
        box-shadow: none;
        height: auto;
        border-radius: 0;
      }

      &.selected {
        div {
          background-color: var(--contextual2);
          color: #fff;
        }
        div, input {
          border-color: var(--contextual2);
        }
      }

      &:hover, &:focus {
        div,
        input {
          border-color: var(--contextual2);
        }
      }
    }
  }

  .modal-header {
    background: var(--contextual2);
    display: block;

    h1::after {
      content: none;
    }
  }

  cite.alert {
    display: block;
  }

  .btn-group {
    outline: 0;
  }

  #whoAreYou {
    .card {
      background: var(--f-o2);
    }

    .btn-group {
      .active, :active {
        box-shadow: none;
      }

      i {
        color: #757575;
      }
    }

    .input-group-prepend .input-group-text {
      color: #757575;
      background: #fff;
      border-top: 0px;
      border-left: 0px;
      border-right: 0px;
      border-bottom-color: #fff;
      border-radius: 0;
      min-width: 44px;
    }

    input, select {
      border-top: 0px;
      border-left: 0px;
      border-right: 0px;
      // width: 100%;
      border-radius: 0;
      box-shadow: none;
    }

    #address1 {
      border-bottom-style: dashed;
    }

    #email,
    #nickname,
    #country {
      border-bottom-color: #fff;
    }

    #nickname[readonly="readonly"] {
      border-bottom-color: #e9ecef;
    }

    #firstname, #city {
      border-left: 1px solid #ccc;
    }
  }

  #whoAreYou {
    .btn.active {
      span { border-bottom: 3px solid var(--contextual2); }
      i { color: var(--contextual2); }
    }
  }

  #payment{
    .active, :active {
      box-shadow: none;
    }
  }

  #btnVerif {
    background-color: var(--contextual2);
    border: 1px solid var(--contextual2);
    color: #fff;
    font-size: 1.75rem;
    margin: 1rem 0;
    padding: .75rem 2.5rem;

    &:hover, &:focus {
      opacity: 0.9;
    }
  }

  .help-block li {
    font-size: 12px;
  }

  .clearfix.help-block {
    margin-left: -2em;
    margin-right: -2em;
    margin-bottom: -1em;
    margin-top: 0;
    padding: 1em 2em;
    background: #f5f5f5;
    border-top: 1px solid #eee;
  }

  /* Bootstrap "soutenir" */
  .text-soutenir {
    color: var(--f-o7);
  }

  #actions {
    background: var(--f-g7) linear-gradient(to bottom right, var(--f-g8), var(--f-g6));

    h1 {
      background: var(--f-o6);
      border-radius: .5rem;
      color: #fff;
      font-family: 'Tovari Sans', sans-serif;
      font-size: 2.4rem;
      @media (min-width: 576px) {
        font-size: 3rem;
      }
      font-style: normal;
      line-height: 2.5rem;
      padding: 1.25rem 1.75rem .5rem;
      text-align: center;
      text-transform: uppercase;
      transform: rotate(-2deg);
      width: fit-content;
      margin: -5rem auto 3rem 0 !important;
    }

    h2 {
      font-family: 'Tovari Sans', sans-serif;
      font-size: 2.4rem;
      @media (min-width: 576px) {
        font-size: 3rem;
      }
      line-height: 2.5rem;
      margin-bottom: 1rem;
      text-transform: none;
      transform: none;
    }

    a {
      background: none;
      color: var(--f-d1);
      text-decoration: underline !important;
    }

    .fa-cogs,
    .fa-people-carry {
       --square: 1em;
    }
  }

  #quotes blockquote p:last-of-type {
    text-align: right;
  }

  #lastyear {
    h2 {
      background: var(--f-o6);
      border-radius: .5rem;
      color: #fff;
      font-family: 'Tovari Sans', sans-serif;
      font-size: 2.4rem;
      @media (min-width: 576px) {
        font-size: 3rem;
      }
      font-style: normal;
      line-height: 2.5rem;
      padding: 1.25rem 1.75rem .5rem;
      text-align: center;
      text-transform: uppercase;
      transform: rotate(-2deg);
      width: fit-content;
      margin: -5rem auto 4rem 0;
    }

    h3 {
      color: var(--f-i9);
      font-family: 'Tovari Sans', sans-serif;
      font-size: 2.4rem;
      @media (min-width: 576px) {
        font-size: 3rem;
      }
      line-height: 2.5rem;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;
      padding: 1rem 1.5rem;
      width: 100%;
      height: 100%;
      margin: 0;
    }

    li {
      margin-bottom: .5rem;

      b {
        font-size: 1.2rem;
        font-weight: normal;
      }
    }

    .col-md-4 {
      > div:last-of-type {
        background: var(--f-o3);
        border-radius: 2rem 0 2rem 2rem;
      }

      .fa-shape-circle {
        border-color: var(--f-o4);
        color: var(--f-o6);
        margin-bottom: .5rem;
      }

      &:first-of-type {
        > div:last-of-type {
          background: var(--f-r3);
          border-radius: 0 2rem 2rem 2rem;
        }

        .fa-shape-circle {
          border-color: var(--f-r4);
          color: var(--f-r6);
        }
      }

      &:last-of-type {
        > div:last-of-type {
          background: var(--f-b3);
          border-radius:  2rem 2rem 0 2rem;
        }

        .fa-shape-circle {
          border-color: var(--f-b4);
          color: var(--f-b6);
        }
      }

      .fa-users {
        --square: 1em;
      }
    }

    .money .card {
      border: 3px solid transparent;
      border-image: linear-gradient(to left bottom,
        var(--f-o5),var(--f-g2) 15%,
        var(--f-g2) 85%,var(--f-o5)) 1;
      background: linear-gradient(to bottom right,var(--f-o2),var(--f-o1));

      ul {
        width: max-content;
      }
    }
  }
}
</style>
